// extracted by mini-css-extract-plugin
export var container = "_8o-0";
export var error = "_8o-9";
export var label = "_8o-5";
export var light = "_8o-6";
export var md = "_8o-3";
export var sm = "_8o-2";
export var thin = "_8o-8";
export var thinBold = "_8o-7";
export var vertical = "_8o-4";
export var xs = "_8o-1";